import React from "react";

interface RemediationSwitchModalProps {
  show: boolean;
  phoneNumber: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation modal shown when a user changes a phone number's service type
 * from Remediation to Scanning (monitor-only). Matches MVC #remediationModal.
 */
const RemediationSwitchModal: React.FC<RemediationSwitchModalProps> = ({
  show,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">Confirmation</h3>
            <button type="button" className="btn-close" onClick={onCancel} />
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-12">
                <span>Are you sure you want to set this phone number to monitor only?</span>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              No
            </button>
            <button type="button" className="btn btn-primary" onClick={onConfirm}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemediationSwitchModal;
